module.exports = __webpack_public_path__ + "static/media/birdseye.fee4ab8b.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/products/agency/assets/birdseye.png
// module id = 234
// module chunks = 0